import React from "react";
import DialogueBox from "../../DialogueBox";
import ImageCropper from "../../ImageCropper";
import ConfirmPrompt from "../../ConfirmationPrompt";

const LogoUploadModal = ({
  isModal,
  isConfirmation,
  setIsModal,
  setIsConfirmation,
  onImageSuccess,
  onImageRemove,
}) => (
  <DialogueBox
    overlayClassName="modal"
    contentClassName="modalContent animated faster fadeInUpx2 small"
    shouldCloseOnOverlayClick={false}
    isOpen={isModal || isConfirmation}
    onRequestClose={() => {
      setIsModal(false);
    }}
  >
    {isConfirmation ? (
      <ConfirmPrompt
        message={"Are you sure you wish to remove Organization logo?"}
        onCancelClick={() => setIsConfirmation(false)}
        onRemoveClick={onImageRemove}
        isLogoFooter={true}
        class={"modalBody"}
        removeButtonText={"Remove"}
        footerClass={"modalFooter"}
        cancelText={"Cancel"}
      />
    ) : (
      <ImageCropper
        wrapperCls="row_block flexGrow"
        uploadText="Set as organization logo"
        title="UPLOAD LOGO"
        onClose={() => setIsModal(false)}
        onSuccess={onImageSuccess}
        moduleType="org"
      />
    )}
  </DialogueBox>
);

export default LogoUploadModal;
